import { fValor } from "../../lib/trading";

export const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
export const lMes = (m) => `${MES[Number(m.slice(5, 7)) - 1]} ${m.slice(2, 4)}`;
export const lDia = (d) => `${d.slice(8, 10)}-${MES[Number(d.slice(5, 7)) - 1]}-${d.slice(2, 4)}`;
export const M = (v) => fValor(v, "money");
export const P2 = (v) => `${(v * 100).toFixed(2)}%`;
export const N0 = (v) => v.toFixed(0);

// Barras agrupadas en eje categórico: cada categoría ocupa n ranuras + 1 de separación (whitespace).
export const agrupar = (cats, defs) => {
  const n = defs.length, labels = [], data = defs.map(() => []);
  cats.forEach((c, i) => {
    for (let j = 0; j <= n; j += 1) {
      labels.push(c);
      defs.forEach((d, k) => data[k].push(j === k && d.vals[i] != null ? { value: d.vals[i] } : {}));
    }
  });
  return { labels, series: defs.map((d, k) => ({ ...d, type: d.type || "histogram", data: data[k] })) };
};

// Barras apiladas (superpuestas con acumulados): la primera serie es el total y cada siguiente se dibuja encima.
export const apilar = (defs) => {
  const acc = defs.map((d, k) => d.vals.map((_, i) => defs.slice(k).reduce((a, x) => a + (x.vals[i] || 0), 0)));
  return defs.map((d, k) => ({ ...d, type: "histogram", data: acc[k].map((v, i) => (d.vals[i] == null ? {} : { value: v })), fmt: d.fmt, real: d.vals }));
};

// Línea alineada al eje categórico (un punto por categoría; null = sin dato).
export const linea = (vals) => vals.map((v) => (v == null ? {} : { value: v }));
